import { cssVar } from '@streamlain/theme';
import { cssVarV2 } from '@streamlain/theme/v2';
import { assignInlineVars } from '@vanilla-extract/dynamic';

import * as styles from './desktop/styles.css';
import type { NotificationStyle, NotificationTheme } from './types';

export const getCardColor = (
  style: NotificationStyle,
  theme: NotificationTheme
) => {
  if (style === 'information') {
    const map: Record<NotificationTheme, string> = {
      error: cssVarV2('layer/background/error'),
      info: cssVarV2('brand/primaryTint'),
      success: cssVarV2('layer/background/success'),
      warning: cssVarV2('layer/background/warning'),
    };
    return map[theme];
  }

  if (style === 'alert') {
    const map: Record<NotificationTheme, string> = {
      error: cssVarV2('status/error'),
      info: cssVarV2('brand/primary'),
      success: cssVarV2('status/success'),
      warning: cssVarV2('chip/tag/orange'),
    };
    return map[theme];
  }

  return cssVarV2('layer/white');
};

export const getActionTextColor = (
  style: NotificationStyle,
  theme: NotificationTheme
) => {
  if (style === 'information') {
    const map: Record<NotificationTheme, string> = {
      error: cssVarV2('status/error'),
      info: cssVarV2('brand/primary'),
      success: cssVarV2('status/success'),
      warning: cssVarV2('text/highlight/fg/orange'),
    };
    return map[theme];
  }

  return getCardForegroundColor(style);
};

export const getCardBorderColor = (style: NotificationStyle) => {
  return style === 'normal'
    ? cssVarV2('layer/insideBorder/border')
    : cssVarV2('layer/blackAlpha/10');
};

export const getCardForegroundColor = (style: NotificationStyle) => {
  return style === 'alert' ? cssVar('pureWhite') : cssVarV2('text/primary');
};

export const getIconColor = (
  style: NotificationStyle,
  theme: NotificationTheme,
  iconColor?: string
) => {
  if (style !== 'alert') {
    const map: Record<NotificationTheme, string> = {
      error: cssVarV2('status/error'),
      info: cssVarV2('brand/primary'),
      success: cssVarV2('status/success'),
      warning: cssVarV2('text/highlight/fg/orange'),
    };
    return iconColor || map[theme];
  }

  return iconColor || cssVar('pureWhite');
};

export const getCloseIconColor = (style: NotificationStyle) => {
  return style === 'alert'
    ? getCardForegroundColor(style)
    : cssVarV2('icon/primary');
};

export const getCardVars = (
  style: NotificationStyle,
  theme: NotificationTheme,
  iconColor?: string
) => {
  return assignInlineVars({
    [styles.cardColor]: getCardColor(style, theme),
    [styles.cardBorderColor]: getCardBorderColor(style),
    [styles.cardForeground]: getCardForegroundColor(style),
    [styles.actionTextColor]: getActionTextColor(style, theme),
    [styles.iconColor]: getIconColor(style, theme, iconColor),
    [styles.closeIconColor]: getCloseIconColor(style),
  });
};
